import './Highlights.css';
export default {
    "wrapper": "Highlights_wrapper__1ei5z",
    "highlightItem": "Highlights_highlightItem__1ei5z"
};
